export default {
  NODE_ENV: import.meta.env.NODE_ENV,
  REACT_APP_BACKEND_URL: import.meta.env.REACT_APP_BACKEND_URL,
  REACT_APP_SENTRY_DSN: import.meta.env.REACT_APP_SENTRY_DSN,
  VITE_REACT_APP_VERSION: import.meta.env.VITE_REACT_APP_VERSION,
  VITE_CONTENT_SECURITY_POLICY_ADDITIONAL_SRC: import.meta.env
    .CONTENT_SECURITY_POLICY_ADDITIONAL_SRC,
};
